module.exports = __webpack_public_path__ + "media/8.74fdf03d.mp3";